module.exports = __webpack_public_path__ + "static/img01__pc-5545a7e7c3611c8d91657a9791330974.svg";